import React, {useEffect, useState} from "react";
import {loadDownlineAgencies} from "../../api/agencies";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import cn from "./DownlineAgencySelector.module.scss";

export function DownlineAgencySelector({ onChange, defaultValue }) {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const updateSearch = (event, value) => {
    setSearch(value);
  };
  const updateValue = (event, value) => {
    if (onChange) {
      onChange(value);
    }
  };

  const handleOpen = () => {
    if (!options.length) {
      setSearch('');
    }
  };

  useEffect(() => {
    let active = true;
    (async() => {
      try {
        setIsLoading(true);
        const agencies = await loadDownlineAgencies(search);
        if (active) {
          setOptions(agencies);
        }
      } catch (err) {
        console.log("loadDownlineAgencies error", err);
      }
      finally {
        setIsLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  },[search]);

  return (
    <Autocomplete
      options={options}
      getOptionLabel={option => option.displayName}
      onInputChange={updateSearch}
      onChange={updateValue}
      onOpen={handleOpen}
      defaultValue={defaultValue}
      loading={isLoading}
      disableClearable={true}
      renderInput={params => (
        <TextField {...params} fullWidth classes={{ root: cn.autocompleteControl }} styles={{margin: 0}} variant="outlined" />
      )}
    />
  );
}
